import { createMiddleware } from "@tanstack/react-start";

/**
 * Client-side server-function middleware that attaches the Supabase bearer
 * token. Functionally identical to the generated `attachSupabaseAuth`, but the
 * supabase-js client (~200KB) is imported dynamically so it is code-split into
 * its own chunk instead of shipping in the shared entry bundle of every page.
 * The chunk is only fetched the first time a server function is called.
 */
export const attachSupabaseAuthLazy = createMiddleware({
  type: "function",
}).client(async ({ next }) => {
  try {
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  } catch {
    return next({ headers: {} });
  }
});
